import { Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Link, Menu, MenuItem, Snackbar, TextField, useMediaQuery, useTheme } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import { useAppContext } from "../../hooks/AppContext";
import { useDispatch, useSelector } from "react-redux";
import { addChecklistItem, deleteChecklistItem, getTask, markChecklistItemComplete, markTaskComplete, renameChecklistItem, setChecklistItemChecked, snoozeTask, updateTaskBody, updateTaskDates, updateTaskTitle } from "../../services/GraphService/GraphService";
import { replaceSlot } from "../../features/slots/slotsSlice";
import { SlotsBoard } from "../../features/slots/SlotsBoard";
import dateTimeUtils, { getFormattedSeconds } from "../../utils/DateTimeUtils";
import Paper from '@mui/material/Paper';
import AddIcon from '@mui/icons-material/Add';
import LinkIcon from '@mui/icons-material/Link';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import CountdownTimer from "../../components/CountdownTimer";
import { StorageUtils } from "../../utils/StorageUtils";
import { ProgressOverlay } from "../../components/ProgressOverlay";
import Autocomplete from "@mui/material/Autocomplete";
import { playCompleteSound, playSnoozeSound } from "../../utils/SoundUtils";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
const LOCATION_REGEX = /{"latitude":[-0-9]*\.[0-9]*,"longitude":[-0-9]*\.[0-9]*}/g;
// the location is stored as JSON inside the body, so the notes box shows the body without it
const notesFromBody = (content) => content.replace(LOCATION_REGEX, "").trimEnd();
const bodyFrom = (notes, locationJson) => locationJson ? `${notes.trimEnd()}\n\n${locationJson}` : notes;
const labelStyle = {
    transform: 'translate(0, -1.5px) scale(0.75)',
    transformOrigin: 'top left'
};
export const TaskDetailView = ({ open, closeDetailDialog, slot }) => {
    var _a, _b, _c;
    const app = useAppContext();
    const dispatch = useDispatch();
    const board = SlotsBoard.createSlotsBoardFromJson(useSelector((state) => state.slots));
    const [bCompleted, setCompleted] = useState(slot.isComplete());
    const [postponeMenuAnchor, setPostponeMenuAnchor] = useState(null);
    const [datePickerOpen, setDatePickerOpen] = useState(false);
    const [pickedDate, setPickedDate] = useState(null);
    const [editingItemId, setEditingItemId] = useState(null);
    const [itemDraft, setItemDraft] = useState('');
    const cancelItemRename = React.useRef(false);
    const [snackUndo, setSnackUndo] = useState(null);
    const [editingTitle, setEditingTitle] = useState(false);
    const [titleDraft, setTitleDraft] = useState('');
    const [notes, setNotes] = useState('');
    const [savedNotes, setSavedNotes] = useState('');
    const [dateEditor, setDateEditor] = useState(null);
    const [editedDate, setEditedDate] = useState(null);
    const [editedTime, setEditedTime] = useState('09:00');
    const [bCountdown, setCountdown] = useState(false);
    const [task, setTask] = useState();
    const [items, setItems] = useState([]);
    const [bBackdrop, setBackdrop] = useState(false);
    const [workedTime, setWorkedTime] = useState(0);
    const theme = useTheme();
    // Search opens this dialog with a throwaway slot that shares a name with a board slot, so the board
    // slot only counts when it holds this same task
    const boardSlot = board.getSlots().find(s => {
        var _a, _b;
        return s.getName() === slot.getName() && !s.isEmpty()
            && ((_a = s.getTaskId()) === null || _a === void 0 ? void 0 : _a.taskId) === ((_b = slot.getTaskId()) === null || _b === void 0 ? void 0 : _b.taskId)
            && s.getCheckListItemId() === slot.getCheckListItemId();
    });
    const themedLabelStyle = Object.assign(Object.assign({}, labelStyle), { color: theme.palette.text.secondary });
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const taskId = slot.getTaskId();
    const addChecklistItemRef = React.useRef();
    const [bProgressOverlayOpen, setProgressOverlayOpen] = useState(false);
    const [bOpenSnack, setOpenSnack] = useState(false);
    const [snackTitle, setSnackTitle] = useState('');
    const [savedLocations, setSavedLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const retrieveTask = async () => {
        var _a, _b, _c, _d;
        const task = await getTask(taskId, slot.type, app.authProvider);
        // const items = await getCheckListItems(taskId, app.authProvider)
        setTask(task);
        setItems(((_a = task.todoTask) === null || _a === void 0 ? void 0 : _a.checklistItems) != undefined ?
            (_b = task.todoTask) === null || _b === void 0 ? void 0 : _b.checklistItems : []);
        // setItems(items)
        setWorkedTime(StorageUtils.loadWorkedTimeFromStorage((_c = app.user) === null || _c === void 0 ? void 0 : _c.userPrincipalName, (_d = slot.tid) === null || _d === void 0 ? void 0 : _d.taskId));
    };
    useEffect(() => {
        setProgressOverlayOpen(true);
        retrieveTask().finally(() => { setProgressOverlayOpen(false); });
        const locs = localStorage.getItem('com.boushar.locations');
        if (locs) {
            try {
                setSavedLocations(JSON.parse(locs));
            }
            catch (e) {
                console.error("Failed to parse locations", e);
            }
        }
    }, []);
    useEffect(() => {
        var _a;
        if (task) {
            let content = ((_a = task.getBody()) === null || _a === void 0 ? void 0 : _a.content) || "";
            const regex = /{"latitude":[-0-9]*\.[0-9]*,"longitude":[-0-9]*\.[0-9]*}/;
            const match = content.match(regex);
            if (match) {
                try {
                    const geo = JSON.parse(match[0]);
                    const foundLoc = savedLocations.find(loc => Math.abs(loc.latitude - geo.latitude) < 0.001 && Math.abs(loc.longitude - geo.longitude) < 0.001);
                    if (foundLoc) {
                        setSelectedLocation(foundLoc);
                    }
                    else {
                        setSelectedLocation({ title: 'Unknown', latitude: geo.latitude, longitude: geo.longitude });
                    }
                }
                catch (e) {
                    console.error("Failed to parse location from task body", e);
                }
            }
            else {
                setSelectedLocation(null);
            }
        }
    }, [task, savedLocations]);
    useEffect(() => {
        var _a;
        if (task) {
            const fromServer = notesFromBody(((_a = task.getBody()) === null || _a === void 0 ? void 0 : _a.content) || "");
            // leave notes the user is still typing alone when the task is refreshed for another action
            setNotes(prev => prev === savedNotes ? fromServer : prev);
            setSavedNotes(fromServer);
        }
    }, [task]);
    const updateItem = (id, fields) => setItems((prevItems) => prevItems.map((item) => item.id === id ? Object.assign(Object.assign({}, item), fields) : item));
    const showSnack = (title) => {
        setSnackTitle(title);
        setOpenSnack(true);
    };
    const toggleCheckbox = async (event, i) => {
        const checked = event.target.checked;
        if (checked) {
            playCompleteSound();
        }
        updateItem(i.id, { isChecked: checked });
        try {
            await setChecklistItemChecked(task === null || task === void 0 ? void 0 : task.getId(), i.id, checked, app.authProvider);
        }
        catch (e) {
            updateItem(i.id, { isChecked: !checked });
            showSnack('Could not update the item');
        }
    };
    const renameItem = async (item, name) => {
        setEditingItemId(null);
        const displayName = name.trim();
        if (!displayName || displayName === item.displayName)
            return;
        updateItem(item.id, { displayName });
        try {
            await renameChecklistItem(task === null || task === void 0 ? void 0 : task.getId(), item.id, displayName, app.authProvider);
            showSnack('Renamed');
        }
        catch (e) {
            updateItem(item.id, { displayName: item.displayName });
            showSnack('Could not rename the item');
        }
    };
    const deleteItem = async (item) => {
        setItems((prevItems) => prevItems.filter((x) => x.id !== item.id));
        try {
            await deleteChecklistItem(task === null || task === void 0 ? void 0 : task.getId(), item.id, app.authProvider);
            const title = `Deleted: ${item.displayName}`;
            setSnackUndo({ title, undo: async () => {
                    setOpenSnack(false);
                    await addChecklistItem(item.displayName, taskId, app.authProvider);
                    await retrieveTask();
                } });
            showSnack(title);
        }
        catch (e) {
            retrieveTask();
            showSnack('Could not delete the item');
        }
    };
    const $items = items.map((i) => (React.createElement("div", { key: i.id, style: { display: 'flex', alignItems: 'center' } },
        React.createElement(Checkbox, { onChange: (e) => { toggleCheckbox(e, i); }, size: "small", checked: i.isChecked }),
        editingItemId === i.id ?
            React.createElement(TextField, { autoFocus: true, size: "small", variant: "standard", value: itemDraft, style: { flexGrow: 1 }, onChange: (e) => setItemDraft(e.target.value), onBlur: () => {
                    if (cancelItemRename.current) {
                        cancelItemRename.current = false;
                        return;
                    }
                    renameItem(i, itemDraft);
                }, onKeyDown: (e) => {
                    if (e.key === 'Enter')
                        e.target.blur();
                    if (e.key === 'Escape') {
                        cancelItemRename.current = true;
                        setEditingItemId(null);
                    }
                }, inputProps: { 'aria-label': 'Checklist item' } }) :
            React.createElement("div", { style: { flexGrow: 1, cursor: 'text', textDecoration: i.isChecked ? "line-through" : "none" }, onClick: () => { setItemDraft(i.displayName); setEditingItemId(i.id); } }, i.displayName),
        React.createElement(IconButton, { size: "small", "aria-label": `Delete ${i.displayName}`, onClick: () => deleteItem(i) },
            React.createElement(DeleteOutlineIcon, { fontSize: "small" })))));
    const handleMarkComplete = async () => {
        var _a, _b;
        playCompleteSound();
        setBackdrop(true);
        try {
            if (slot.isCheckListItem()) {
                await markChecklistItemComplete(taskId, slot.getCheckListItemId(), app.authProvider);
            }
            else {
                await markTaskComplete(slot, app.authProvider);
            }
            slot.status = "completed";
            setCompleted(true);
            if (boardSlot) {
                dispatch(replaceSlot(slot.object()));
            }
            setSnackTitle(`Completed: ${(_b = (_a = slot.title) !== null && _a !== void 0 ? _a : task === null || task === void 0 ? void 0 : task.getTitle()) !== null && _b !== void 0 ? _b : ''}`);
            setOpenSnack(true);
        }
        finally {
            setBackdrop(false);
        }
    };
    /*const locationUpdate = () => {
       navigator.geolocation.getCurrentPosition((position) => {
          const geo: GeoCoordinates = {
             latitude: position.coords.latitude,
             longitude: position.coords.longitude
          }
          updateLocation(geo, taskId!, app.authProvider!)
       })
    }*/
    const postponeToOffset = async (offsetDays) => {
        playSnoozeSound();
        setPostponeMenuAnchor(null);
        setBackdrop(true);
        try {
            const response = await snoozeTask(slot, offsetDays, app.authProvider);
            if (boardSlot) {
                slot.status = 'postponed';
                dispatch(replaceSlot(slot.object()));
            }
            setSnackTitle(`Postponed: ${response.title}`);
            setOpenSnack(true);
            await retrieveTask();
        }
        finally {
            setBackdrop(false);
        }
    };
    const handlePostponeToTomorrow = () => postponeToOffset(1);
    const handlePostponeToNextMonday = () => {
        const offset = moment().add(1, 'week').startOf('isoWeek').diff(moment().startOf('day'), 'days');
        postponeToOffset(offset);
    };
    const handleOpenDatePicker = () => {
        setPostponeMenuAnchor(null);
        setPickedDate(null);
        setDatePickerOpen(true);
    };
    const openDateEditor = (which) => {
        const current = which === 'due' ? task === null || task === void 0 ? void 0 : task.getDueDateTime() : task === null || task === void 0 ? void 0 : task.getReminderDateTime();
        const existing = current ? moment(dateTimeUtils(current).toDate()) : null;
        setEditedDate(existing);
        setEditedTime(which === 'reminder' && existing ? existing.format('HH:mm') : '09:00');
        setDateEditor(which);
    };
    const saveDate = async (clear) => {
        const which = dateEditor;
        if (!which || (!clear && !editedDate))
            return;
        setDateEditor(null);
        setBackdrop(true);
        try {
            let value = null;
            if (!clear) {
                value = which === 'due' ? editedDate.format('YYYY-MM-DD') : `${editedDate.format('YYYY-MM-DD')}T${editedTime}:00`;
            }
            await updateTaskDates(which === 'due' ? { dueDateTime: value } : { reminderDateTime: value }, taskId, app.authProvider);
            const name = which === 'due' ? 'Due date' : 'Reminder';
            setSnackTitle(clear ? `${name} cleared` : `${name} set`);
            setOpenSnack(true);
            await retrieveTask();
        }
        finally {
            setBackdrop(false);
        }
    };
    const handleConfirmDate = () => {
        if (!pickedDate)
            return;
        const offset = pickedDate.diff(moment().startOf('day'), 'days');
        if (offset < 1)
            return;
        setDatePickerOpen(false);
        postponeToOffset(offset);
    };
    const onAddChecklistItem = async () => {
        // call graphservice add checklistitem
        await addChecklistItem(addChecklistItemRef.current.value, taskId, app.authProvider);
        setSnackTitle(`Added: ${addChecklistItemRef.current.value}`);
        setOpenSnack(true);
        addChecklistItemRef.current.value = "";
        retrieveTask();
    };
    const handleChecklistItemInputKeyUp = (event) => {
        if (event.key === 'Enter') {
            onAddChecklistItem();
        }
    };
    const handleSnackClose = (_, reason) => {
        if (reason == 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const handleAssignLocation = async () => {
        if (!selectedLocation)
            return;
        const geo = { latitude: selectedLocation.latitude, longitude: selectedLocation.longitude };
        const geoString = JSON.stringify(geo);
        await updateTaskBody(bodyFrom(notes, geoString), taskId, app.authProvider);
        setSnackTitle(`Location assigned: ${selectedLocation.title}`);
        setOpenSnack(true);
        retrieveTask();
    };
    const handleRemoveLocation = async () => {
        if (hasTaskLocation) {
            await updateTaskBody(notes, taskId, app.authProvider);
            setSnackTitle(`Location removed`);
            setOpenSnack(true);
            retrieveTask();
        }
    };
    const startEditingTitle = () => {
        var _a;
        setTitleDraft((_a = task === null || task === void 0 ? void 0 : task.getTitle()) !== null && _a !== void 0 ? _a : '');
        setEditingTitle(true);
    };
    const handleSaveTitle = async () => {
        const title = titleDraft.trim();
        if (!title || title === (task === null || task === void 0 ? void 0 : task.getTitle()))
            return;
        setEditingTitle(false);
        setBackdrop(true);
        try {
            await updateTaskTitle(title, taskId, app.authProvider);
            if (boardSlot) {
                slot.title = title;
                dispatch(replaceSlot(slot.object()));
            }
            setSnackTitle('Renamed');
            setOpenSnack(true);
            await retrieveTask();
        }
        finally {
            setBackdrop(false);
        }
    };
    const handleSaveNotes = async () => {
        setBackdrop(true);
        try {
            await updateTaskBody(bodyFrom(notes, currentTaskLocationStr), taskId, app.authProvider);
            setSnackTitle('Notes saved');
            setOpenSnack(true);
            await retrieveTask();
        }
        finally {
            setBackdrop(false);
        }
    };
    const currentTaskLocationStr = ((_c = (_b = (_a = task === null || task === void 0 ? void 0 : task.getBody()) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.match(/{"latitude":[-0-9]*\.[0-9]*,"longitude":[-0-9]*\.[0-9]*}/)) === null || _c === void 0 ? void 0 : _c[0]) || "";
    const hasTaskLocation = !!currentTaskLocationStr;
    // a flagged email keeps its dates on the message flag, which updateTaskDates doesn't handle
    const editableDates = slot.type !== 'Message';
    // a subtask slot opens its parent task here, so renaming would rename the parent, not the subtask
    const editableTitle = slot.type === 'TodoTask' && !slot.isCheckListItem();
    const dateButtonSx = { justifyContent: 'flex-start', p: 0, minWidth: 0, textTransform: 'none', font: 'inherit', color: 'inherit' };
    return (React.createElement(React.Fragment, null,
        React.createElement(Snackbar, { open: bOpenSnack, autoHideDuration: 6000, anchorOrigin: { vertical: 'top', horizontal: 'center' }, message: snackTitle, onClose: handleSnackClose, action: (snackUndo === null || snackUndo === void 0 ? void 0 : snackUndo.title) === snackTitle ?
                React.createElement(Button, { color: "inherit", size: "small", onClick: snackUndo.undo }, "Undo") : undefined }),
        React.createElement(ProgressOverlay, { open: bProgressOverlayOpen }),
        React.createElement(Dialog, { open: open, fullScreen: fullScreen },
            React.createElement(DialogContent, { style: { backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : '#faf9f8' } },
                React.createElement(Backdrop, { open: bBackdrop, sx: { zIndex: (theme) => theme.zIndex.drawer + 1 } },
                    React.createElement(CircularProgress, { color: "inherit" })),
                React.createElement("div", { style: { display: 'grid', gridTemplateColumns: '1fr', gap: '10px' } },
                    React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                        React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 } },
                            editingTitle ?
                                React.createElement(React.Fragment, null,
                                    React.createElement(TextField, { autoFocus: true, multiline: true, fullWidth: true, size: "small", variant: "standard", value: titleDraft, onChange: (e) => setTitleDraft(e.target.value.replace(/\n/g, ' ')), onFocus: (e) => e.target.setSelectionRange(e.target.value.length, e.target.value.length), onKeyDown: (e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleSaveTitle();
                                            }
                                            if (e.key === 'Escape') {
                                                e.stopPropagation();
                                                setEditingTitle(false);
                                            }
                                        }, sx: { minWidth: 0, flex: 1 }, InputProps: { sx: { fontSize: '1.25rem', fontWeight: 500, lineHeight: 1.5 } }, inputProps: { 'aria-label': 'Task title' } }),
                                    React.createElement(IconButton, { size: "small", "aria-label": "Save title", onClick: handleSaveTitle, disabled: !titleDraft.trim() || titleDraft.trim() === (task === null || task === void 0 ? void 0 : task.getTitle()) },
                                        React.createElement(CheckIcon, { fontSize: "small" })),
                                    React.createElement(IconButton, { size: "small", "aria-label": "Cancel", onClick: () => setEditingTitle(false) },
                                        React.createElement(CloseIcon, { fontSize: "small" }))) :
                                React.createElement(React.Fragment, null,
                                    React.createElement("div", { style: { fontSize: '1.25rem', fontWeight: 500 } }, task === null || task === void 0 ? void 0 : task.getTitle()),
                                    editableTitle && task &&
                                        React.createElement(IconButton, { size: "small", "aria-label": "Rename task", onClick: startEditingTitle },
                                            React.createElement(EditIcon, { fontSize: "small" }))),
                            (task === null || task === void 0 ? void 0 : task.isRecurring()) && React.createElement(AutorenewIcon, { fontSize: "small", titleAccess: "Recurring", color: "action" })),
                        React.createElement("div", null,
                            React.createElement(Link, { target: "_blank", href: `https://to-do.live.com/tasks/id/${taskId === null || taskId === void 0 ? void 0 : taskId.taskId}/details` },
                                React.createElement(LinkIcon, null)))),
                    task === null && React.createElement("div", null, "Loading"),
                    task !== null &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '8px' } },
                                bCompleted ?
                                    React.createElement(Button, { variant: "outlined", size: "small", startIcon: React.createElement(CheckIcon, null), disabled: true }, "Completed") :
                                    React.createElement(Button, { variant: "contained", size: "small", onClick: handleMarkComplete }, "Mark complete"),
                                !bCompleted &&
                                    React.createElement(Button, { variant: "outlined", size: "small", onClick: (e) => setPostponeMenuAnchor(e.currentTarget) }, "Postpone")),
                            React.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '10px' } },
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                                    React.createElement("label", { style: themedLabelStyle }, "Time Spent"),
                                    React.createElement("div", null, getFormattedSeconds(workedTime))),
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                                    React.createElement("label", { style: themedLabelStyle }, "Reminder Date"),
                                    editableDates
                                        ? React.createElement(Button, { size: "small", sx: dateButtonSx, onClick: () => openDateEditor('reminder') }, (task === null || task === void 0 ? void 0 : task.getReminderDateTime()) ? dateTimeUtils(task.getReminderDateTime()).format("M/D/Y H:mm") : React.createElement(AddIcon, { fontSize: "small", titleAccess: "Set date", sx: { color: theme.palette.text.disabled } }))
                                        : React.createElement("div", null, (task === null || task === void 0 ? void 0 : task.getReminderDateTime()) ? dateTimeUtils(task === null || task === void 0 ? void 0 : task.getReminderDateTime()).format("M/D/Y H:mm") : "")),
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                                    React.createElement("label", { style: themedLabelStyle }, "Due Date"),
                                    editableDates
                                        ? React.createElement(Button, { size: "small", sx: dateButtonSx, onClick: () => openDateEditor('due') }, (task === null || task === void 0 ? void 0 : task.getDueDateTime()) ? dateTimeUtils(task.getDueDateTime()).format("M/D/Y") : React.createElement(AddIcon, { fontSize: "small", titleAccess: "Set date", sx: { color: theme.palette.text.disabled } }))
                                        : React.createElement("div", null, (task === null || task === void 0 ? void 0 : task.getDueDateTime()) ? dateTimeUtils(task.getDueDateTime()).format("M/D/Y") : ""))),
                            React.createElement(Divider, null),
                            React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', marginTop: 10, marginBottom: 10 } },
                                React.createElement(Autocomplete, { options: selectedLocation && selectedLocation.title === 'Unknown' ? [...savedLocations, selectedLocation] : savedLocations, getOptionLabel: (option) => option.title || "", isOptionEqualToValue: (option, value) => Math.abs(option.latitude - value.latitude) < 0.001 && Math.abs(option.longitude - value.longitude) < 0.001, value: selectedLocation, onChange: (e, newValue) => setSelectedLocation(newValue), renderInput: (params) => React.createElement(TextField, Object.assign({}, params, { label: "Assign Location", size: "small", variant: "standard" })), sx: { flex: 1, minWidth: '200px' } }),
                                React.createElement("div", { style: { display: 'flex', gap: '8px' } },
                                    React.createElement(Button, { variant: "outlined", size: "small", onClick: handleAssignLocation, disabled: !selectedLocation }, "Set Location"),
                                    React.createElement(Button, { variant: "outlined", color: "error", size: "small", onClick: handleRemoveLocation, disabled: !hasTaskLocation }, "Remove"))),
                            React.createElement("div", { style: { width: '100%', display: 'flex' } },
                                React.createElement(TextField, { variant: "standard", size: "small", placeholder: "Add Checklist item", inputRef: addChecklistItemRef, style: { flexGrow: 1 }, inputProps: { style: { flexGrow: 1 } }, onKeyUp: handleChecklistItemInputKeyUp }),
                                React.createElement(IconButton, { onClick: onAddChecklistItem },
                                    React.createElement(AddIcon, null))),
                            React.createElement("div", { style: { width: '100%', display: 'flex', flexDirection: 'column' } }, $items),
                            React.createElement(Divider, null),
                            React.createElement(Paper, { elevation: 0, style: { marginBottom: '10px' } },
                                React.createElement(TextField, { multiline: true, fullWidth: true, placeholder: "Notes", value: notes, onChange: (e) => setNotes(e.target.value) })),
                            notes !== savedNotes &&
                                React.createElement("div", { style: { display: 'flex', gap: '8px', justifyContent: 'flex-end' } },
                                    React.createElement(Button, { size: "small", onClick: () => setNotes(savedNotes) }, "Revert"),
                                    React.createElement(Button, { size: "small", variant: "contained", onClick: handleSaveNotes }, "Save notes")))),
                React.createElement("div", { style: { display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '16px' } },
                    React.createElement(Button, { variant: "contained", onClick: () => setCountdown(true) }, "Start"),
                    React.createElement(Button, { variant: "contained", onClick: closeDetailDialog }, "Close")),
                React.createElement(Menu, { open: Boolean(postponeMenuAnchor), anchorEl: postponeMenuAnchor, onClose: () => setPostponeMenuAnchor(null) },
                    React.createElement(MenuItem, { onClick: handlePostponeToTomorrow }, "Tomorrow"),
                    React.createElement(MenuItem, { onClick: handlePostponeToNextMonday }, "Next Monday"),
                    React.createElement(MenuItem, { onClick: handleOpenDatePicker }, "Pick a date\u2026")),
                React.createElement(Dialog, { open: datePickerOpen, onClose: () => setDatePickerOpen(false) },
                    React.createElement(DialogTitle, null, "Pick a date"),
                    React.createElement(DialogContent, null,
                        React.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
                            React.createElement(DateCalendar, { value: pickedDate, onChange: (date) => setPickedDate(date), disablePast: true }))),
                    React.createElement(DialogActions, null,
                        React.createElement(Button, { onClick: () => setDatePickerOpen(false) }, "Cancel"),
                        React.createElement(Button, { onClick: handleConfirmDate, variant: "contained", disabled: !pickedDate }, "Confirm"))),
                React.createElement(Dialog, { open: dateEditor !== null, onClose: () => setDateEditor(null) },
                    React.createElement(DialogTitle, null, dateEditor === 'due' ? 'Due date' : 'Reminder'),
                    React.createElement(DialogContent, null,
                        React.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
                            React.createElement(DateCalendar, { value: editedDate, onChange: (date) => setEditedDate(date) })),
                        dateEditor === 'reminder' &&
                            React.createElement(TextField, { type: "time", label: "Time", size: "small", value: editedTime, onChange: (e) => setEditedTime(e.target.value || '09:00'), InputLabelProps: { shrink: true } })),
                    React.createElement(DialogActions, null,
                        React.createElement(Button, { onClick: () => setDateEditor(null) }, "Cancel"),
                        React.createElement(Button, { color: "error", onClick: () => saveDate(true), disabled: !(dateEditor === 'due' ? task === null || task === void 0 ? void 0 : task.getDueDateTime() : task === null || task === void 0 ? void 0 : task.getReminderDateTime()) }, "Clear"),
                        React.createElement(Button, { variant: "contained", onClick: () => saveDate(false), disabled: !editedDate }, "Save"))),
                bCountdown && React.createElement(CountdownTimer, { handleClose: () => setCountdown(false), slot: slot })))));
};
